import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import useFetch from "../useFetch";
import { useNavigate } from "react-router-dom";
import handleBackendResponse from "../../Utils/handleNotifications/handleBackendResponse";

export default function useHandleTimeOffById(userId) {
  const navigate = useNavigate(),
    fetch = useFetch(navigate);

  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/user/timeoffs?userId=${userId}`,
    {
      onSuccess: (data) =>
        console.log("users timeoff fetched successfully:", data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    },
  );
  const allPto = data?.data;
  const filterAprovedPto = data?.data?.filter((pto) => pto.status !== 2) || [];
  const allAprovedPto =
    filterAprovedPto?.map((pto) => ({
      colorId: pto.status === 1 ? 2 : 3,
      allDay: pto.status !== 1,
      text:
        pto.status === 1
          ? pto?.comment || "Approved time off"
          : "Pending time off",
      startDate: pto?.ptoDates?.startDate,
      endDate: pto?.ptoDates?.endDate,
      comments: pto?.comments,
      status: pto?.status,
    })) || [];

  const handlePostTimeOff = async (formData, comment) => {
    const startDateTime = new Date(formData.startDate);
    const endDateTime = new Date(formData.endDate);
    startDateTime.setHours(formData.startTime, 0, 0);
    endDateTime.setHours(formData.endTime, 0, 0);

    const startDate = startDateTime.toLocaleString();
    const endDate = endDateTime.toLocaleString();

    const body = {
      ptoDates: {
        startDate,
        endDate,
      },
      comment: comment,
    };

    const response = await fetch.post(`${apiBaseURL}/api/user/timeoffs`, body);
    const isDataGood = handleBackendResponse(response);

    if (isDataGood) await mutate();

    return isDataGood;
  };

  return {
    allPto,
    allAprovedPto,
    isLoading,
    handlePostTimeOff,
    error,
    mutate,
  };
}
